import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { JobService } from 'src/app/services/job/job.service';

@Component({
  selector: 'app-view-question-answer',
  templateUrl: './view-question-answer.component.html',
  styleUrls: ['./view-question-answer.component.scss']
})
export class ViewQuestionAnswerComponent {
  isExpandAll:boolean=false;
  public panelOpenState: boolean = true;
  public questionArr:any[]=[
    {
      que:"How many experience does you have of this field?",
      ans:"asdsadas"
    },
    {
      que:"What are key points in thermodynamics?",
      ans:"wew"
    }
  ]
  constructor(private appService:AppService,private jobService:JobService,private commonService:CommonService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,public dialogRef: MatDialogRef<ViewQuestionAnswerComponent>,
  ){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.getQuestionList()
  }
  onExpandAll(){
    this.isExpandAll=!this.isExpandAll
   }
  onCancel(){}
  onSubmit(){}

  getQuestionList(){
    let obj = {
     "j_id": this.dialogData.id,
    "em_i":this.dialogData.em_i
    }
    this.jobService.getQuestionList(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.questionArr=[]
          this.questionArr=success.msg
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }})
  }
}
